
const state = {
  brand_group_id: undefined,
  id: null,
  publication_id: undefined,
}

export const requiredFields = [
  { key: 'brand_group_id' },
  { key: 'publication_id' },
]

export default state
